export enum ACTION {
    SET_USER
}
